// extracted by mini-css-extract-plugin
export default {"root":"h-scrollable-content_root__yVEzE","placeHolderShimmer":"h-scrollable-content_placeHolderShimmer__-tkWM"};